module.exports = __webpack_public_path__ + "static/media/6301.894f23f7.svg";